<template>
  <div class="page-wrapper">
    <Header :user="user" />
    <div class="terms-and-conditions">
      <div class="terms-and-conditions__container container container--big">
        <div class="terms-and-conditions__top">
          <div class="terms-and-conditions__top-title">Terms of Service</div>
        </div>
      </div>
      <div class="terms-and-conditions__terms-conditions">
        <div class="terms-and-conditions__terms-conditions-wrapper">
          <p class="subtitle">
            Mental Future Terms of Service
          </p>
          <p>
            This Internet site represents a legal document that serves as our Terms and Conditions of Service
            (<b>“Terms”</b>)
            and it governs the legal terms of our website, mentalfuture.com, sub-domains, and any associated web-based
            and mobile applications (collectively, <b>“Website”</b>), as owned and operated by the following limited
            liability
            company: Mental Future Ltd, duly registered and existing under the laws of Bulgaria (hereinafter <b>“Mental
              Future”</b>). These Terms apply to all the users of the Website throughout the world. For contact
            information
            and other corporate details of Mental Future, please see the “Contact Us” section at the end of these Terms.
          </p>
          <p class="subtitle">
            Scope of Terms
          </p>
          <p>
            These Terms apply to your use of the Website, including any content made available therein. Any different or
            additional terms that you agree to in relation to some of the services or products we offer on the Website
            become part of your agreement with us, if you use them. The legal relationship between Mental Future and the
            user for the use of the Website is exclusively subject to these Terms and any such additional terms. If
            there is a conflict between these Terms and any such additional terms, the additional terms will take
            precedence in each particular case. Any conflicting terms provided by you or any other user do not apply,
            even if we do not object to them. If you do not agree to be bound by these Terms, you may not use the
            Website.
          </p>
          <p class="subtitle">
            Privacy Policy
          </p>
          <p>
            Please refer to our Privacy Policy (mentalfuture.com/privacy-policy) for information on how we collect, use
            and disclose information about you.
          </p>
          <p class="subtitle">
            Changes to Terms
          </p>
          <p>
            We may amend our Terms at any time without specific notice to you. We may do this from time to time with
            effect for the future for valid reasons, such as to, for example, reflect changes to our products and
            services or for market conditions (e.g., adding new features or benefits to the services, retiring certain
            features of certain services) or for legal, regulatory or security reasons. The latest versions of our Terms
            are posted on our Website, and prior to using our Website you are advised to acquaint yourself and review
            all Terms. Posting any of the revisions to our Terms on our Website creates the presumption that you agree
            to be bound to any such amendments to them. Therefore, it is important for you to periodically review our
            Terms to make sure you still understand them and agree to them.
            You have the right to object to any such changes at any time by ceasing your use of the services and you may
            cancel any subscription you have at any time as explained in the “Termination” Section of these Terms. By
            accessing the Website, you are agreeing to be bound by these Website Terms, as well as by all applicable
            laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If
            you do not agree with any of these Terms, you are prohibited from using or accessing this Website. The
            materials contained in this Website are protected by applicable copyright and trademark law.
          </p>
          <p class="subtitle">
            Definitions
          </p>
          <p>
            The terms <b>“us”</b> or <b>“we”</b> or <b>“our”</b> refers to Mental Future, the owner of the Website.
            <br>
            A <b>“Visitor”</b> is someone who merely browses our Website, but has not registered as Member.
            <br>
            A <b>“Member”</b> is an individual that has a subscription and has registered with us to use our service.
            <br>
            The terms <b>“you”</b> or <b>“your”</b> refers either to a Member or a Visitor that makes use of the
            service.
            <br>
            Our <b>“Services”</b> represent the collective functionalities and features as offered through our Website
            to our
            Members.
            <br>
            Our <b>“Products”</b> are items and programmes that can be purchased through the Services through our
            Website.
            <br>
            A <b>“User”</b> is a collective identifier that refers to either a Visitor or a Member.
            <br>
            All text, information, graphics, audio, video, and data offered through our Website are collectively known
            as our <b>“Content”</b> or otherwise made available through the Services and Products.
            <br>
            <b>“User Content”</b> means any Content that Users (including you) provide to be made available through the
            Services and Products. Content includes without limitation User Content.
          </p>
          <p class="subtitle">
            Modifying and Terminating our Services and Products
          </p>
          <p>
            Subject to the terms of this Section, we may change or discontinue all or any part of the Services or
            Products at any time. To avoid any doubt, nothing in these Terms affects any mandatory legal rights and
            remedies you have under the applicable law of your jurisdiction. If any such change or discontinuance would
            unreasonably disadvantage you or otherwise significantly disturb the contractual balance between the
            parties, including changes to the essential characteristics of the Service, you can object by terminating
            your subscription. We are not responsible for any loss or harm related to your inability to access or use
            our Services and Products.
          </p>
          <p class="subtitle">
            Who May Use the Services or Products
          </p>
          <p>
            <b>
              <i>
                Eligibility
              </i>
            </b>
          </p>
          <p>
            You may use the Services or Products only if you are 16 years or older and are not barred from using the
            Services or Products under applicable law. If you are under 18 years of age (or the age of legal majority
            where you have your domicile), you may use our Services or Products only under the supervision of a parent
            or a legal guardian who agrees to be bound by these Terms. Any parent or legal guardian of a User under the
            age of 18 (or the age of
            legal majority as the case may be) who has reviewed these Terms as required by the previous sentence, hereby
            agrees to be fully responsible for the acts or omissions of such user in relation to our Services and
            Products. If you use our Services or Products on behalf of another person or entity, (a) all references to
            “you” throughout these Terms will include that person or entity, (b) you represent that you are authorised
            to accept these Terms on that person’s or entity’s behalf, and (c) in the event you, the person or entity
            violates these Terms, both you and the other person or entity agree to be jointly and severally responsible
            and liable for any such violation. To make a purchase via the Services (described in the Section titled
            <b>“Purchases”</b> below), you must be 18 years or older and capable of forming a binding contract. Certain
            Services may not be available in all jurisdictions, and we reserve the right to impose additional
            eligibility requirements, which will be provided in advance of your acceptance of such requirements.
          </p>
          <p>
            <b>
              <i>
                Account Registration and Security
              </i>
            </b>
          </p>
          <p>
            If you want to use certain features of the Services or certain Products, including if you want to sign up
            for a free trial or purchase a subscription, you will have to register for an account (“Account”). You can
            do this via the Website, or any other application or your account with certain third-party social networking
            services such as Facebook. If you choose to register through a third-party social networking service, we
            shall create your Account by extracting from your account with the social networking service certain
            personal information such as your name and email address and other personal information that your privacy
            settings on the social networking service account permit us to access. If you register for an Account via
            the Website, or any other application, you must provide us with accurate, complete and up-to-date
            information and promptly update such information, as needed, to keep it accurate, complete and up-to-date.
            If you do not do that, we shall be obliged to suspend or terminate your Account. You will maintain the
            security of your Account and Account password and will not disclose your Account password to anyone. You
            will notify us immediately if you discover or suspect any unauthorised use of your Account. We reserve the
            right to reclaim usernames, including on behalf of businesses or individuals that hold legal claims,
            including trademark rights, in those usernames.
          </p>
          <p class="subtitle">
            Purchases
          </p>
          <p>
            <b>
              <i>
                Fees for Subscriptions and Products
              </i>
            </b>
          </p>
          <p>
            Mental Future offers certain enhanced features of the Services which you can access (i) by purchasing a
            monthly, yearly or lifetime subscription (<b>“Individual Subscription”</b>); or (ii) through a partnership
            between
            Mental Future and your organisation (<b>“Corporate Subscription”</b>). A description of features associated
            with
            Individual Subscriptions and Corporate Subscriptions is available via the Services. For Corporate
            Subscriptions, your ability to access and use the Services may be subject to additional terms between you
            and your organisation. When you purchase an Individual Subscription or a Product (each, a
            <b>“Transaction”</b>), we
            may ask you to supply additional information relevant to your Transaction, such as your credit card number,
            the expiration date of your credit card and your address(es) for billing (collectively, <b>“Payment
              Information”</b>). You represent and warrant that you have the legal right to use all payment method(s)
            represented by any such Payment Information. The amounts due and payable by you for a Transaction through
            the Services will be presented to you before you place your order. If you choose to initiate a Transaction
            through the Services, you authorise us to provide your Payment Information to third-party service providers
            so we can complete your Transaction and agree (i) to pay the applicable fees and any taxes specified at the
            time of purchase; (ii) that Mental Future may charge your credit card or third-party payment processing
            account, including, but not limited to, your account with the app store or distribution platform (like the
            Apple App Store, Google Play or the Amazon Appstore) where any of our applications is made available (each,
            an <b>“App Provider”</b>), may be charged; and (iii) to bear any additional charges that your App Provider,
            bank or
            other financial service provider may levy on you. You will receive a confirmation email after we confirm the
            payment for your order. Your order is not binding on Mental Future until accepted and confirmed by Mental
            Future. All payments made are non-refundable and non-transferable except as expressly provided in these
            Terms. If you have any concerns or objections regarding charges, you will raise them with us first and you
            will not cancel or reject any credit card or third-party payment processing charges, unless you have made a
            reasonable attempt at resolving the matter directly with Mental Future. Mental Future reserves the right to
            not process or to cancel your order in certain circumstances, for example, if your credit card is declined,
            if we suspect the request or order is fraudulent, or in other circumstances Mental Future deems appropriate
            in its reasonable discretion. Mental Future also reserves the right, in its sole discretion, to take steps
            to verify your identity in connection with your order in accordance with requirements under applicable data
            protection law. You may need to provide additional information to verify your identity before completing
            your Transaction (such information is included within the definition of Payment Information). Mental Future
            will either not charge you or refund the charges for orders that we do not process or cancel. When you
            access our Services as part of a Corporate Subscription purchased by your organisation, you will follow the
            instructions provided by your organisation pursuant to the terms of its agreement with Mental Future. In
            this case, these Terms will also form a direct contract between you and Mental Future.
          </p>
          <p>
            <b>
              <i>
                Individual Subscriptions Automatically Renew Until You Cancel & How to Cancel Your Individual
                Subscription
              </i>
            </b>
          </p>
          <p>
            The timing of your payment and the automatic renewal of your Individual Subscription will depend on the
            duration of your Individual Subscription period and are subject to cancellation rights specified in these
            Terms. For lifetime Individual Subscriptions, all amounts are payable and charged at the time you place your
            order. For monthly or yearly Individual Subscriptions, which renew automatically for an additional
            subscription period equal in length to the expiring subscription period until you cancel, all amounts are
            payable: (i) at the beginning of the subscription period and (ii) at the time of each renewal until you
            cancel, using the Payment Information you have provided. You must cancel your monthly or yearly Individual
            Subscription, before it renews to avoid the billing of the fees for the next Individual Subscription period.
            You will receive a prior notice that your renewal is approaching. If you purchase your Individual
            Subscription via the Website, you can cancel the renewal of your Individual Subscription at any time by
            contacting us by email at <a href="mailto:help@mentalfuture.com">help@mentalfuture.com</a>. If you
            purchase your Individual Subscription via an App
            Provider, you can cancel the renewal of your Individual Subscription at any time with the
            App Provider. When you purchase through an App Provider, the App Provider’s terms of sale will apply to such
            purchases and these Terms will apply to your use of Services. If you used a promo code, coupon code, or
            other discount to sign up for a subscription, your subscription will automatically renew at the then-current
            price at the end of the discounted-price period, except where another promotional offer applies to you.
            Except as expressly provided in these Terms, you will not receive a refund for the fees you already paid for
            your current Individual Subscription period and you will continue to receive the Services until the end of
            your then-current Individual Subscription period. Apple handles all billing for in-app purchases made on iOS
            devices. Customers who subscribed to Mental Future through iTunes will need to reach out to Apple directly
            with any refund requests. They are typically able to honour all refund requests within 30 days of the
            purchase date (but this is at essentially at their full and absolute discretion). You should contact Apple
            directly for details.
          </p>
          <p>
            <b>
              <i>
                Free Trials
              </i>
            </b>
          </p>
          <p>
            Your Subscription may start with a free trial (the <b>“Free Trial”</b>). If we offer you a Free Trial, the
            specific
            terms of your Free Trial will be provided in the marketing materials describing the particular trial or at
            registration. Free Trials are for new and former customers only. Mental Future reserves the right, in its
            reasonable discretion, to determine your Free Trial eligibility and to modify or cancel the terms offered
            for its Free Trials (on a going-forward basis for new Free Trials) at any time. ONCE YOUR FREE TRIAL ENDS,
            WE (OR OUR THIRD PARTY PAYMENT PROCESSOR) WILL BEGIN BILLING YOUR DESIGNATED PAYMENT METHOD ON A RECURRING
            BASIS FOR YOUR SUBSCRIPTION (PLUS ANY APPLICABLE TAXES AND OTHER CHARGES SPECIFIED AT THE TIME OF PURCHASE)
            FOR AS LONG AS YOUR SUBSCRIPTION CONTINUES, UNLESS YOU CANCEL YOUR SUBSCRIPTION PRIOR TO THE END OF YOUR
            FREE TRIAL. If you initiated your Free Trial via the Website, you can cancel your Free Trial at any time by
            going to mentalfuture.com and logging into your Mental Future account. If you initiated your Free Trial via
            an App Provider, you can cancel the renewal of your Individual Subscription at any time with the App
            Provider. Your Free Trial period in no way limits the rights you are entitled to within the scope of your
            statutory right of withdrawal.
          </p>
          <p>
            <b>
              <i>
                Right of Withdrawal
              </i>
            </b>
          </p>
          <p>
            If you register for an Individual Subscription, you have the right to withdraw this contract within fourteen
            (14) days from the day you sign up for the relevant Services without giving reasons (the <b>“Withdrawal
              Period”</b>). If you sign up for a Free Trial, the Withdrawal Period ends fourteen (14) days after you
            start the
            Free Trial. If you purchase an Individual Subscription without a Free Trial, the Withdrawal Period is
            available for fourteen (14) days after your purchase. To exercise this right of withdrawal, you must send a
            clear, written request of your decision to withdraw from this contract to: <a
              href="mailto:help@mentalfuture.com">help@mentalfuture.com</a>
          </p>
          <p>
            <b>
              <i>
                Changes to Price Terms for Individual Subscriptions and Products
              </i>
            </b>
          </p>
          <p>
            Mental Future may adjust the prices for ongoing contracts/services on the basis of these Terms, at its
            reasonable discretion, and in line with the development of the costs, which are decisive for the price
            calculation. Any such price increase or decrease will apply to the new renewal period for the Subscription.
            If you do not agree to the price, you may terminate your Subscription before the new renewal period begins.
            A price increase or decrease shall be considered, if, for example, the costs for the procurement of
            hardware, software and energy, the use of communication networks or labour costs increase or decrease or if
            other changes in the economic or legal framework conditions lead to a changed cost situation. Mental Future
            shall inform the User about changes in the price in writing at least 30 days before the changes come into
            effect. Prices for new contracts for Services and prices of Products may be changed at any time at the sole
            discretion of Mental Future.
          </p>
          <p>
            <b>
              <i>
                Future Functionality
              </i>
            </b>
          </p>
          <p>
            You agree that your purchases are not contingent on the delivery of any future functionality, content or
            features, or dependent on any oral or written public comments made by Mental Future regarding future
            functionality or features.
          </p>
          <p>
            <b>
              <i>
                Feedback
              </i>
            </b>
          </p>
          <p>
            We welcome and encourage feedback, comments, questions, and ideas about Mental Future or the Services or
            Products, and suggestions for improvements to the Services or Products (collectively, <b>“Feedback”</b>).
            You can
            submit Feedback by emailing us at <a href="mailto:help@mentalfuture.com">help@mentalfuture.com</a>. By
            submitting or providing any Feedback, you
            agree that your submissions are voluntary, gratuitous and without restriction, and will not place Mental
            Future under any obligations to you or any other party. You grant to us a non-exclusive, worldwide,
            perpetual, irrevocable, fully-paid, royalty-free, sublicensable and transferable licence under any and all
            intellectual property rights that you own or control to use, copy, modify, create derivative works based
            upon and otherwise exploit the Feedback for any purpose, commercial or otherwise, without acknowledgement or
            compensation to you, including, without limitation, to develop, copy, publish, or improve the Feedback in
            Mental Future’s sole discretion. You understand that Mental Future may treat Feedback as non confidential.
            Mental Future does not waive any rights to use similar or related ideas previously known to Mental Future,
            developed by its employees or obtained from other sources.
          </p>
          <p class="subtitle">
            Content and Content Intellectual Property Rights
          </p>
          <p>
            <b>
              <i>
                Content Ownership
              </i>
            </b>
          </p>
          <p>
            Except for the licence you grant below, Mental Future does not claim any ownership rights in any User
            Content and nothing in these Terms will be deemed to restrict any mandatory rights that you may have to use
            and exploit your User Content, as between you and Mental Future. Subject to the foregoing, Mental Future and
            its licensors exclusively own all right, title and interest in and to the Services, Products and Content,
            including all associated intellectual property rights. You acknowledge that the Services, Products and
            Content are protected by copyright, trademark, and other laws of the United States and foreign countries.
            You will not remove, alter or obscure any copyright, trademark, service mark or other proprietary rights
            notices incorporated in or accompanying the Services, Product or Content.
          </p>
          <p>
            <b>
              <i>
                Rights in User Content Granted by You
              </i>
            </b>
          </p>
          <p>
            By making any User Content available through the Services and Products you hereby grant to Mental Future a
            non-exclusive, transferable, sublicensable, worldwide, royalty-free and fully paid licence to use, publish,
            translate, reproduce, adapt, copy, modify, create derivative works based upon, publicly display, publicly
            perform and distribute your User Content via the Services. When you post or otherwise share User Content on
            or through our Services, you understand that your User Content and any associated information (such as your
            username or profile photo) may be visible to others. You represent and warrant that your User Content, and
            our use of such content as permitted by these Terms, will not violate any rights of or cause injury to any
            person or entity.
          </p>
          <p>
            <b>
              <i>
                Rights in Content Granted by Mental Future
              </i>
            </b>
          </p>
          <p>
            Subject to these Terms, Mental Future grants you a limited, non-exclusive, non-transferable,
            non-sublicensable, revocable licence to access and use the Content solely in connection with your permitted
            use of the Services and Products and solely for your personal and non-commercial purposes. Any use of the
            Services and Products other than as specifically authorised herein, without our prior written permission, is
            strictly prohibited, will terminate the licence granted herein and violate our intellectual property rights.
          </p>
          <p>
            <b>
              <i>
                Complaints
              </i>
            </b>
          </p>
          <p>
            We have adopted a policy of terminating the Accounts of Users who repeatedly infringe the rights of others.
            If you believe that anything on our Services infringes any right that you own or control or the rights of a
            third party (e.g., counterfeiting, insult, invasion of privacy) or if you discover that User Content
            promotes crimes against humanity, incites racial hatred and/or violence or concerns child pornography,
            please immediately notify Mental Future as follows: <a
              href="mailto:help@mentalfuture.com">help@mentalfuture.com</a>. When submitting a notice, you
            must identify the date of notification; if you are a natural person: your full name, e-mail address and
            nationality, a description of the content being reported and its precise location (e.g. URL link to the
            disputed content); and the reasons why the content must be removed.
          </p>
          <p class="subtitle">
            Rights and Terms for Applications
          </p>
          <p>
            <b>
              <i>
                Rights in Applications Granted by Mental Future
              </i>
            </b>
          </p>
          <p>
            Subject to your compliance with these Terms, Mental Future grants you a limited non-exclusive,
            non-transferable, non-sublicensable licence to download and install a copy of any available applications
            developed by Mental Future on a mobile device or computer that you own or control and to run such copy of
            the applications solely for your own personal non-commercial purposes. Mental Future reserves all rights in
            and to the applications not expressly granted to you under these Terms. You may not copy the applications,
            except for making a reasonable number of copies for backup or archival purposes. Except as expressly
            permitted in these Terms, you may not: (a) copy, modify or create derivative works based on the
            applications; (b) distribute, transfer, sublicense, lease, lend or rent the applications to any third-party;
            (c) reverse engineer, decompile or disassemble the applications, except to the limited extent expressly
            authorised by statute (where applicable); or (d) make the functionality of the applications available to
            multiple users through any means.
          </p>
          <p>
            <b>
              <i>
                Additional Terms for App Store Applications
              </i>
            </b>
          </p>
          <p>
            If you accessed or downloaded the Mental Future application from the Apple Store, then you agree to use it
            only: (a) on an Apple-branded product or device that runs iOS (Apple’s proprietary operating system
            software); and (b) as permitted by the <b>“Usage Rules”</b> set forth in the Apple Store Terms of Service.
            <br>
            If you accessed or downloaded the Mental Future application from an App Provider, then you acknowledge and
            agree that:
            <br>
          <ul>
            <li>
              These Terms are concluded between you and Mental Future, and not with App Provider, and that, as between
              Mental Future and the App Provider, Mental Future, is solely responsible for the Mental Future
              application.
            </li>
            <li>
              App Provider has no obligation to furnish any maintenance and support services with respect to the Mental
              Future application.
            </li>
            <li>
              In the event of any failure of the Mental Future application to conform to any applicable warranty, you
              may notify App Provider and App Provider will refund the purchase price for the Mental Future application
              to you (if applicable) and, to the maximum extent permitted by applicable law, App Provider will have no
              other warranty obligation whatsoever with respect to the Mental Future application. Any other claims,
              losses, liabilities, damages, costs or expenses attributable to any failure of an Mental Future
              application to conform to any warranty will be the sole responsibility of Mental Future.
            </li>
            <li>
              App Provider is not responsible for addressing any claims you have or any claims of any third-party
              relating to the App or your possession and use of the Mental Future application, including, but not
              limited to: (a) product liability claims; (b) any claim that the Mental Future application fails to
              conform to any applicable legal or regulatory requirement; and (c) claims arising under consumer
              protection or similar legislation.
            </li>
            <li>
              In the event of any third-party claim that the Mental Future application or your possession and use of the
              App infringes that third-party’s intellectual property rights, Mental Future will be solely responsible
              for the investigation, defence, settlement and discharge of any such intellectual property infringement
              claim to the extent required by these Terms.
            </li>
            <li>
              App Provider and its subsidiaries are third-party beneficiaries of these Terms as related to your licence
              of the Mental Future application, and that, upon your acceptance of the terms and conditions of these
              Terms, App Provider will have the right (and will be deemed to have accepted the right) to enforce these
              Terms as related to your licence of the App against you as a third-party beneficiary thereof.
            </li>
            <li>
              You must also comply with all applicable third-party terms of service when using the Mental Future
              application.
            </li>
            <li>
              You may not export or re-export the Mental Future application, any technical data related thereto, or any
              content contained therein, except as authorised by export control and sanctions laws of the United States
              and any other government having jurisdiction. By using the App you represent and warrant that in
              particular, but without limitation, the App, related technology and the content contained therein
              may not be exported or re-exported to: (i) any U.S. sanctioned or embargoed countries or regions; or (ii)
              any person or entity on the U.S. Treasury Department's list of Specially Designated Nationals, the U.S.
              Department of Commerce Denied Persons List or Entity List, or other U.S. sanctions or export control
              lists.
            </li>
          </ul>
          </p>
          <p>
            <b>
              <i>
                Prohibitions on User Content and Conduct
              </i>
            </b>
          </p>
          <p>
            You agree that you are solely responsible for your conduct and User Content while using our Services and
            Products, and will not to do any of the following:
            <br>
          <ul>
            <li>
              Post, upload, create, publish, store, submit, transmit or otherwise share any User Content that: (a) is
              confidential and for which you do not have all necessary rights to disclose or to grant us the license
              described above; (b) may infringe, misappropriate or violate a third-party’s patent, copyright, trademark,
              trade secret, moral rights or other intellectual property rights, or rights of publicity or privacy; (c)
              violates, or encourages any conduct that would violate, these Terms, the rights of any party or otherwise
              create liability or violate any applicable local, state, national or international law or regulation or
              would give rise to civil or criminal liability; (d) is fraudulent, false, misleading or deceptive; (e)
              impersonates or misrepresents your affiliation with, any person or entity or contains or depicts any
              statements, remarks or claims that do not reflect your honest views and experiences; (f) is defamatory,
              obscene, pornographic, vulgar, offensive, unlawful, libelous, indecent, lewd, suggestive, abusive, or
              inflammatory; (g) promotes discrimination, bigotry, racism, hatred, harassment or harm against any
              individual or group; (h) is violent or threatening or promotes violence or actions that are threatening to
              any person or entity; (i) promotes illegal or harmful activities or substances; (j) contains any
              unsolicited or unauthorized promotions, political campaigning, advertising or solicitations; (k) contains
              any viruses, corrupted data or other harmful, disruptive or destructive files or content; or (l) in our
              reasonable judgment, is objectionable, restricts or inhibits any other person from using or enjoying our
              Services and Products, or may expose Mental Future or others to any harm or liability of any type;
            </li>
            <li>
              Copy, reproduce, distribute, use, publicly perform or publicly display, mirror or frame the Services or
              Products, or any individual element within the Services or Product, Mental Future’s name, any Mental
              Future trademark, logo or other proprietary information, or the layout and design of any page or form
              contained on a page, without express written consent from Mental Future or its licensors;
            </li>
            <li>
              Modify our Services or Products, remove any proprietary rights notices or markings, or otherwise make any
              derivative works based upon our Services or Products;
            </li>
            <li>
              Use our Services or Products other than for their intended purpose and in any manner not permitted by
              these Terms, that violates these Terms or any applicable law, regulation, contract, intellectual property
              right or other third-party right, or that could interfere with, disrupt, negatively affect or inhibit
              other users from fully enjoying our Services or Products, or that could damage, disable, overburden or
              impair the functioning of our Services or Products in any manner;
            </li>
            <li>
              Develop or use any applications that interact with our Services or Products without our prior written
              consent;
            </li>
            <li>
              Avoid, bypass, ignore, remove, deactivate, impair, descramble or otherwise circumvent any technological
              measure implemented by Mental Future or any of Mental Future’s providers or any other third-party
              (including another user), to
              protect the Services or Products;
            </li>
            <li>
              Attempt to scrape or extract data from our Services or Products or download Content
              from the Services or Products through the use of any engine, software, tool, agent, device or mechanism
              (including spiders, robots, crawlers, data mining tools or the like) other than the software and/or search
              agents provided by Mental Future or other generally available third-party web browsers to circumvent
              measures employed to bypass or prevent or limit access to any part of our Services or Products, including
              instructions contained in any robots.txt file we provide that controls automated access to portions of our
              Services;
            </li>
            <li>
              Attempt to decipher, decompile, disassemble or reverse engineer, except to the limited extent expressly
              authorised by statute (where applicable), any of the software used to provide the Services or Products, or
              do anything that might discover source code;
            </li>
            <li>
              Interfere with, or attempt to interfere with, the access of any user, host or network, including, without
              limitation, sending a virus, overloading, flooding, spamming, or mail-bombing the Services or Products;
            </li>
            <li>
              Collect or store any personally identifiable information from the Services or Products from other users of
              the Services or Products without their express permission;
            </li>
            <li>
              Engage in any harassing, threatening, intimidating, predatory or stalking conduct;
            </li>
            <li>
              Use or attempt to use another user’s account without authorization from that user
              and Mental Future; or
            </li>
            <li>
              Encourage or enable any other individual to do any of the foregoing.
            </li>
          </ul>
          <br>
          <p>
            Although we’re not obligated to monitor access to or use of the Services, Products or Content or to review
            or
            edit any Content, we have the right to do so at any time to ensure compliance with these Terms and to comply
            with applicable law or other legal requirements, with or without notice. We reserve the right, but are not
            obligated, to enforce this section by removing or disabling access to any Content, at any time and without
            notice, if we, in our reasonable judgement, consider any Content to be objectionable or in violation of
            these
            Terms. Our failure to enforce this section in some instances does not constitute a waiver of our right to
            enforce it in other instances. We have the right to investigate violations of these Terms or conduct that
            affects the Services or Products. We may also consult and cooperate with law enforcement authorities to
            prosecute users who violate the law. In addition, this section does not create any private right of action
            on
            the part of any third-party or any reasonable expectation that the Services or Products will not contain any
            Content that is prohibited by such rules.
          </p>
          </p>
          <p>
            <b>
              <i>
                Third-Party Content
              </i>
            </b>
          </p>
          <p>
            The Services or Products may contain information about, and links to, third-party products, services,
            websites, resources, activities or events, or we may allow third parties to make their content and
            information available on or through the Services or Products (collectively, <b>“Third-Party Content”</b>).
            We
            provide Third-Party Content only as a convenience and do not control or endorse any Third-Party Content. You
            acknowledge you are responsible for deciding if you want to access Third-Party Content.
          </p>
          <p>
            <b>
              <i>
                Trademarks
              </i>
            </b>
          </p>
          <p>
            Our product or service names, our slogans and the look and feel of the Services or Products may be
            trademarks of Mental Future (clearly marked as such) and may not be copied, imitated or used, in whole or in
            part, without our prior written permission. All other trademarks, registered trademarks, product names and
            company names or logos mentioned on the Services or Products are the property of their respective owners.
            Reference to any products, services, processes or other information by trade name, trademark, manufacturer,
            supplier or otherwise does not constitute or imply endorsement, sponsorship or recommendation by us.
          </p>
          <p class="subtitle">
            Termination
          </p>
          <p>
            We may terminate or suspend your access to and use of the Services, Products, or Mental Future application
            for good cause. There is a rebuttable presumption of good cause if, taking into account all the
            circumstances of the specific case and weighing the interests of both parties, cannot reasonably be expected
            to continue the contractual relationship, such as if you materially or repeatedly breach these Terms. We may
            also suspend your Account for a period of up to ninety (90) days while we investigate suspected misconduct
            if such misconduct would qualify as good cause and there is sufficient fact-based suspicion of misconduct.
            If you have a Corporate Subscription, we may terminate your Corporate Subscription and your Account, if you
            are no longer eligible for a Corporate Subscription based on the terms of our agreement with your
            organisation. You may terminate your Account or your Subscription at any time by sending an email to us at
            <a href="mailto:help@mentalfuture.com">help@mentalfuture.com</a>. If you purchase an Individual
            Subscription via an App Provider, you must cancel
            your Individual Subscription with the App Provider directly. Upon any termination, discontinuation or
            cancellation of the Services, Products or your Account, all provisions of these Terms which by their nature
            should survive will survive, including, without limitation, ownership provisions, warranty disclaimers,
            limitations of liability, and dispute resolution provisions.
          </p>
          <p class="subtitle">
            Limited Warranty
          </p>
          <p>
            The Service will be provided using a commercially reasonable level of care and skill. Other than as
            expressly stated in these Terms, Mental Future does not make any commitments about the reliability of the
            Services, or the ability of the Services to meet your needs, and disclaims all other warranties.
          </p>
          <p class="subtitle">Medical Disclaimers</p>
          <p>
            By using our Services, Products and Content, you understand and agree that:
            <br>
          <ul>
            <li>
              the Services, Products and Content you receive from Mental Future are non-clinical in nature, provided for
              informational purposes only, and not intended, designed, or implied to diagnose, prevent, or treat any
              condition or disease, to ascertain the state
              of your health, or to be a substitute for professional medical care;
            </li>
            <li>
              Mental Future is not a licensed medical care provider and does not engage in, and has no expertise in,
              diagnosing, examining, or treating medical conditions of any kind, or in prescribing medications or
              treatments or determining the effect of any
              specific treatment on a medical condition;
            </li>
            <li>
              Mental Future does not provide emergency services and may not contact you or
              anyone on your behalf with respect to your medical condition or treatment;
            </li>
            <li>
              Mental Future is not responsible for the effectiveness or correct use of Content you
              receive through or is generated by the Services or Products;
            </li>
            <li>
              You should always consult a physician if you have any questions regardiFng a medical
              condition; and
            </li>
            <li>
              Never disregard professional medical advice or delay in seeking it because of
              something you have read or received using the Services or Products.
            </li>
          </ul>
          </p>
          <p>
            Not all activities described as part of the Services or Products are suitable for everyone. Do not use the
            Services or Products while driving, operating heavy machinery, or performing other tasks that require
            attention and concentration. You agree to use the Services and Products responsibly.
          </p>
          <p class="subtitle">
            Limitation of Liability
          </p>
          <p>
            This section shall not limit liability for damages resulting from injury to life, body or health that are
            based on an intentional or negligent breach of duty by Mental Future or its vicarious agents or for damages
            based on an intentional breach of duty or grossly negligent breach of duty by Mental Future or its vicarious
            agents. For all other damages, Mental Future is only liable for its simple negligent violation of essential
            contractual obligations and such liability shall be limited to the damage foreseeable and typical for the
            contract at the time of conclusion of this agreement. To be clear, essential contractual obligations are
            those whose fulfilment characterises the contract and on which the User may rely. Otherwise, liability is
            excluded. Insofar as the liability of Mental Future is limited or excluded, the limitations or exclusions
            shall also apply to the personal liability of Mental Future’s employees, legal representatives and vicarious
            agents. The limitations and exclusions of liability according to this section do not affect the liability of
            Mental Future according to the mandatory legal provisions of product liability acts in the countries where
            Users are located.
          </p>
          <p class="subtitle">
            Dispute Resolution
          </p>
          <p>
            <b>
              <i>
                Governing Law
              </i>
            </b>
          </p>
          <p>
            These Terms and your access to and use of our Services will be governed by and construed and enforced in
            accordance with the laws of England and Wales, the application of their conflict of laws’ provisions and the
            application of the United Nations Convention of Contracts for the International Sale of Goods are expressly
            excluded.
          </p>
          <p>
            <b>
              <i>
                Arbitration
              </i>
            </b>
          </p>
          <p>
            All disputes arising out of or relating to these Terms, including disputes arising out of or relating to its
            interpretation, invalidity, performance or termination, as well as disputes to fill gaps in the Terms or
            adapt them to new circumstances, shall be resolved by the International Court of Arbitration at the Alliance
            for Legal Interaction, Sofia, Republic of
            Bulgaria, in accordance with its Rules for cases based on arbitration agreements. Nothing in these Terms
            affects your rights as a consumer to rely on mandatory provisions of the jurisdiction in which you are a
            resident. The European Commission provides for an online dispute resolution platform, which you can access
            at <a href="https://ec.europa.eu/consumers/odr/" target="_blank">https://ec.europa.eu/consumers/odr/</a>. We prefer to solve your requests directly with you and therefore,
            unless otherwise agreed to by Mental Future in writing or as specified below, we do not participate in
            alternative consumer dispute resolution proceedings. If you would like to bring a matter to our attention,
            please contact us.
          </p>
          <p class="subtitle">
            General Terms
          </p>
          <p>
            These Terms, together with any different or additional terms agreed to as part of specific Services or Products, constitute the entire and exclusive understanding and agreement between Mental Future and you regarding the Services, Products and Content, and these Terms supersede and replace any and all prior oral or written understandings or agreements between Mental Future and you regarding the Services, Products and Content. If any provision of these Terms is held unlawful, invalid or unenforceable, that provision or part of the provision will be enforced to the maximum extent permissible and is deemed severable from these Terms, and the other provisions of these Terms will remain in full force and effect. Mental Future may freely assign or transfer these Terms without restriction. These Terms will bind and inure to the benefit of the parties, their successors and permitted assigns. Any notices or other communications provided by Mental Future under these Terms, including those regarding changes to these Terms, will be given: (i) by Mental Future via email; or (ii) by posting to the Services. For notices made by e-mail, the date of receipt will be deemed the date on which such notice is received at the server of your email service provider. Mental Future’s failure to enforce any right or provision of these Terms will not be considered a waiver of such right or provision. The waiver of any such right or provision will be effective only if in writing and signed by a duly authorised representative of Mental Future. Except as expressly set forth in these Terms, the exercise by either party of any of its remedies under these Terms will be without prejudice to its other remedies under these Terms or otherwise. The section titles in these Terms are for convenience only and have no legal or contractual effect. Except as otherwise provided herein, these Terms are intended solely for the benefit of the parties and are not intended to confer third-party beneficiary rights upon any other person or entity. You agree that communications and transactions between us may be conducted electronically.
          </p>
          <p class="subtitle">
            Contact Information
          </p>
          <p>
            If you have any questions about these Terms or the Services or Products, please contact Mental Future at: <a href="mailto:help@mentalfuture.com">help@mentalfuture.com</a>.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer.vue";

export default {
  props: ["user"],
  name: "TermsAndConditionsGlobal",
  components: { Header, Footer },
};
</script>

<style lang="scss" scoped>
.terms-and-conditions {

  &__top {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding-top: 25px;
  }

  &__top-title {
    font-weight: 700;
    font-size: 32px;
    line-height: 42px;
    color: var(--color-white);
    padding-bottom: 36px;

    @media (max-width: 991px) {
      padding-bottom: 24px;
      font-size: 24px;
      line-height: 30px;
    }
  }

  &__terms-conditions-wrapper {
    max-width: 848px;
    width: 100%;
    margin-right: auto;
    margin-left: auto;

    @media (max-width: 991px) {
      padding: 0 24px;
    }
  }

  .subtitle {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;

    @media (max-width: 991px) {
      font-size: 18px;
      line-height: 24px;
    }
  }

  p {
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: var(--color-white);
    margin: 16px 0;

    b {
      font-weight: 700;
    }

    a {
      text-decoration: underline;
    }
  }

  ul {
    list-style-type: disc;
    padding-left: 20px;
  }

  li {
    margin-left: 10px;
    color: white;
  }
}
</style>